import { Auth0Client } from "@auth0/auth0-spa-js";
import axios from "axios";

let _client: Auth0Client | null = null;

const getClient = (): Auth0Client => {
  if (!_client) {
    _client = new Auth0Client({
      domain: process.env.REACT_APP_AUTH0_DOMAIN!,
      clientId: process.env.REACT_APP_SERVICE_HUB_CLIENT_ID!,
      authorizationParams: {
        audience: process.env.REACT_APP_SERVICE_HUB_AUDIENCE,
        redirect_uri: window.location.origin,
      },
      cacheLocation: "localstorage",
      useRefreshTokens: true,
    });
  }
  return _client;
};

export const getServiceHubToken = (): Promise<string> =>
  getClient().getTokenSilently();

export const loginServiceHubWithPopup = (): Promise<void> =>
  getClient().loginWithPopup({
    authorizationParams: {
      audience: process.env.REACT_APP_SERVICE_HUB_AUDIENCE,
    },
  });

const CONSENT_ERRORS = new Set([
  "consent_required",
  "interaction_required",
  "login_required",
  "missing_refresh_token",
]);

interface Auth0Error extends Error {
  error?: string;
}

export const ensureServiceHubAuth = async (): Promise<void> => {
  try {
    await getServiceHubToken();
  } catch (e) {
    if (CONSENT_ERRORS.has((e as Auth0Error).error ?? "")) {
      await loginServiceHubWithPopup();
    } else {
      throw e;
    }
  }
};

export async function prefetchServiceHubToken(): Promise<void> {
  try {
    await getClient().getTokenSilently();
  } catch {
    // SSO session may not exist — silent fail is expected
  }
}

export const serviceHubAxios = axios.create({
  baseURL: process.env.REACT_APP_SERVICE_HUB_URL,
});

serviceHubAxios.interceptors.request.use(async (config) => {
  const token = await getServiceHubToken();
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});
